interface LeafMarkProps {
  size?: number;
  fillColor?: string;
  className?: string;
}

// The NLC leaf mark — brass on forest, from logo-viewer.html 2026-05-11
export function LeafMark({ size = 48, fillColor = '#B08D57', className }: LeafMarkProps) {
  return (
    <svg
      viewBox="0 0 72 72"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M36 6C36 6 58 22 58 42C58 56 48 66 36 66C24 66 14 56 14 42C14 22 36 6 36 6Z"
        fill={fillColor}
        opacity="0.9"
      />
      <path
        d="M36 6C36 6 24 22 20 38C22 50 28 60 36 66C26 56 22 46 24 36C26 24 36 6 36 6Z"
        fill="rgba(255,255,255,0.12)"
      />
    </svg>
  );
}
